import Account from "./account";
import AdminCommunication from "./adminCommunication";
import AdminDashboard from "./adminDashboard";
import AdminFinancials from "./adminFinancials";
import AdminReports from "./adminReports";
import AdminProjectsDetails from "./adminProjectsDetails";
import AdminProjectsList from "./adminProjectsList";
import AdminProposals from "./adminProposals";
import AdminRoofingProposals from "./adminRoofingProposals";
import AdminSettings from "./adminSettings";
import AdminUsers from "./adminUsers";
import AdminWorkflows from "./adminWorkflows";
import OutreachTemplates from "./outreachTemplates";
import AmbassadorDashboard from "./ambassador";
import Compensation from "./compensation";
import ActivityCenter from "./activityCenter";
import SellerDashboard from "./dashboard";
import Leads from "./leads";
import SellerDashboardEventsAndUpdates from "./dashboardEventsAndUpdates";
import Earnings from "./earnings";
import EnterpriseDashboard from "./enterpriseDashboard";
import OrgProjectsList from "./orgProjectsList";
import EnterpriseProjectsDetails from "./enterpriseProjectsDetails";
import EnterpriseMarketing from "./enterpriseMarketing";
import EnterpriseEarnings from "./enterpriseEarnings";
import EnterpriseTeam from "./enterpriseTeam";
import EnterpriseApplicationsReview from "./enterpriseApplicationsReview";
import EnterpriseApplicationsDetails from "./enterpriseApplicationsDetails";
import OrgActivityCenter from "./orgActivityCenter";
import BuildPartnerApplicationsDetails from "./buildPartnerApplicationsDetails";
import GettingStarted from "./gettingStarted";
import IconLibrary from "./iconLibrary";
import Marketing from "./marketing";
import PlatformAlerts from "./platformAlerts";
import Profile from "./profile";
import ProjectsDetails from "./projectsDetails";
import ProjectsList from "./projectsList";
import Reports from "./reports";
import TeamIntelligence from "./teamIntelligence";
import Tickets from "./tickets";
import Modules from "./modules";
import AccountTypesRoute from "./accountTypes";
import UserPartnerRequest from "./userPartnerRequest";
import Reactivate from "./reactivate";

/*
  keep routes sorted first by category then by order we would like them to appear in side nav
  important to keep project list views before project detail views as we want router to
  prioritize matching those routes first.
*/
export default [
  /* Category: Reactivation */
  Reactivate,

  /* Category: Personal */
  Profile,
  Account,
  AccountTypesRoute,
  /* Category: Powur */
  Tickets,

  /* Category: Sales */
  GettingStarted,
  SellerDashboard,
  Leads,
  SellerDashboardEventsAndUpdates,
  ProjectsList,
  ProjectsDetails,
  Marketing,
  Earnings,
  Reports,
  TeamIntelligence,
  ActivityCenter,
  AmbassadorDashboard,
  UserPartnerRequest,

  /* Category: Enterprise */
  EnterpriseDashboard,
  OrgProjectsList,
  EnterpriseProjectsDetails,
  EnterpriseMarketing,
  EnterpriseEarnings,
  EnterpriseTeam,
  Modules,
  OrgActivityCenter,

  /* Category: Admin */
  AdminDashboard,
  AdminProjectsList,
  AdminProjectsDetails,
  AdminUsers,
  AdminProposals,
  AdminRoofingProposals,
  OutreachTemplates,
  AdminFinancials,
  AdminReports,
  Compensation,
  PlatformAlerts,
  AdminWorkflows,
  AdminSettings,
  AdminCommunication,
  EnterpriseApplicationsReview,
  EnterpriseApplicationsDetails,
  BuildPartnerApplicationsDetails,

  /* Misc */
  IconLibrary,
];
